import * as React from 'react';

const CurrentLocationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} {...props}>
        <g id="current-location_svg__\xF0\x9F\x94\x84_swap/chunky/current_location">
            <g id="current-location_svg__primary_fill">
                <path d="M15 11.999a3 3 0 11-6 0 3 3 0 016 0z" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 2.332h2V5.07a7.005 7.005 0 015.929 5.929h2.57v2h-2.57a7.005 7.005 0 01-5.93 5.929v2.737h-2v-2.737a7.005 7.005 0 01-5.928-5.93H2.167v-2H5.07A7.005 7.005 0 0111 5.07V2.332zm6.25 9.667A5.256 5.256 0 0012 6.749a5.256 5.256 0 00-5.25 5.25 5.256 5.256 0 005.25 5.25 5.256 5.256 0 005.25-5.25z"
                />
            </g>
        </g>
    </svg>
);

CurrentLocationSvg.displayName = 'CurrentLocationSvg';
export default CurrentLocationSvg;
